module.exports = __webpack_public_path__ + "img/insurance_value.de8efd92.svg";